import pImg1 from "../images/portfolio/portfolio_item_image_1.e53ec6ef2e1a330b3adc.webp";
import pImg2 from "../images/portfolio/portfolio_item_image_2.36b57c5e887ca2f826fe.webp";
import pImg3 from "../images/portfolio/portfolio_item_image_3.21f77bcd7dfd8e654cac.webp";
import pImg4 from "../images/case/case_image_1.e3381eb89b326c9593cf.webp";
import pImg5 from "../images/case/case_image_2.99fcbb632d4cfde03b67.webp";
import pImg6 from "../images/case/case_image_3.c33d8f88811cb89ce5e7.webp";
import pImg7 from "../images/portfolio/portfolio_item_image_4.737e2e3b46b23400684b.webp";
import pImg8 from "../images/portfolio/portfolio_item_image_5.a7a9089f1b8549842614.webp";
import pImg9 from "../images/portfolio/portfolio_item_image_6.89ae35dcd34a1672546d.webp";
import pImg10 from "../images/portfolio/portfolio_item_image_7.f6587b3a8ad5655dc2b9.webp";
import pImg11 from "../images/portfolio/portfolio_item_image_9.ab20009d520c113bbbb8.webp";
import pImg12 from "../images/portfolio/portfolio_item_image_10.e6b04cbf4a3c9bb144d6.webp";
import pImg13 from "../images/portfolio/portfolio_item_image_4.737e2e3b46b23400684b.webp";
import pImg14 from "../images/portfolio/portfolio_item_image_6.89ae35dcd34a1672546d.webp";
import tImg1 from "../images/case/icon_angular.svg";
import tImg2 from "../images/case/icon_elephent.svg";
import tImg3 from "../images/case/icon_netcore.svg";
import tImg4 from "../images/case/vuejs.svg";
import tImg5 from "../images/case/icon_python.svg";
import alhijaz from "../images/portfolio/alhijaz.png";
import minhaj from "../images/portfolio/alminhaj.png";
import moroco from "../images/portfolio/morocco.png";
import saudia from "../images/portfolio/stay-saudia.png";
import hh from "../images/portfolio/haramyn-hotels.png";

const Project = [
  {
    Id: "30",
    pImg: alhijaz,
    title: "Al Hijaz Tours and Travels",
    slug: "Al Hijaz Tours and Travels",
    sub: "Booking Platform",
    category: "booking",
    thumb1: "Booking Platform",
    thumb2: "Travel Agency",
    description:
      "Al Hijaz Tours and Travels is a premier travel agency specializing in Hajj and Umrah packages. With a commitment to providing exceptional service, they offer a range of travel solutions tailored to the needs of pilgrims.",
  },
  {
    Id: "31",
    pImg: minhaj,
    title: "Al Minhaj Tours and Travels",
    slug: "Al Minhaj Tours and Travels",
    sub: "Booking Platform",
    category: "booking",
    thumb1: "Booking Platform",
    thumb2: "Travel Agency",
    description:
      "Al Minhaj Tours and Travels is a premier travel agency specializing in Hajj and Umrah packages. With a commitment to providing exceptional service, they offer a range of travel solutions tailored to the needs of pilgrims.",
  },
  {
    Id: "33",
    pImg: moroco,
    title: "Morocco Excursions",
    slug: "Morocco Excursions",
    sub: "Booking Platform",
    category: "booking",
    thumb1: "Booking Platform",
    thumb2: "Travel Agency",
    description:
      "Morocco Excursions is a premier travel agency specializing in Hajj and Umrah packages. With a commitment to providing exceptional service, they offer a range of travel solutions tailored to the needs of pilgrims.",
  },
  {
    Id: "34",
    pImg: saudia,
    title: "Stay Saudia Hotel Booking Platform",
    slug: "Stay-Saudia-Hotel-Booking-Platform",
    sub: "Hotel Booking Platform",
    category: "booking",
    thumb1: "Booking Platform",
    thumb2: "Travel Agency",
    description:
      "Stay Saudia is a premier hotel booking agency specializing in hotels. With a commitment to providing exceptional service, they offer a range of travel solutions tailored to the needs of pilgrims.",
  },
  {
    Id: "35",
    pImg: hh,
    title: "Haramayn Hotels Booking Platform",
    slug: "Haramayn-Hotels-Hotel-Booking-Platform",
    sub: "Hotel Booking Platform",
    category: "booking",
    thumb1: "Booking Platform",
    thumb2: "Travel Agency",
    description:
      "Haramayn Hotels is a premier hotel booking agency specializing in hotels. With a commitment to providing exceptional service, they offer a range of travel solutions tailored to the needs of pilgrims.",
  },
  {
    Id: "1",
    pImg: pImg1,
    category:'App design',
    title: "Mobile App Design",
    slug: "Mobile-App-Design",
    sub: "App Design",
    description:
      "Our all-encompassing IELTS Coaching curriculum encompasses every aspect...",
  },
  {
    Id: "2",
    pImg: pImg2,
    category:'App design',
    title: "TOEFL Coaching",
    slug: "TOEFL-Coaching",
    sub: "",
    description:
      "Our experienced coaches are not just educators; they are partners in your journey..",
  },
  {
    Id: "3",
    pImg: pImg3,
    category:'App design',
    title: "Dashboard Design",
    slug: "Dashboard-Design",
    sub: "Web Design",
    description:
      "The contents of the citizenship test typically cover a range of subjects ...",
  },
  {
    Id: "4",
    pImg: pImg1,
    category:'App design',
    title: "Mobile App Design",
    slug: "Mobile-App-Design",
    sub: "App Design",
    description:
      "Our all-encompassing IELTS Coaching curriculum encompasses every aspect...",
  },
  {
    Id: "5",
    pImg: pImg2,
    category:'App design',
    title: "TOEFL Coaching",
    slug: "TOEFL-Coaching",
    sub: "",
    description:
      "Our experienced coaches are not just educators; they are partners in your journey..",
  },
  {
    Id: "6",
    pImg: pImg3,
    category:'App design',
    title: "Dashboard Design",
    slug: "Dashboard-Design",
    sub: "Web Design",
    description:
      "The contents of the citizenship test typically cover a range of subjects ...",
  },
  {
    Id: "7",
    pImg: pImg4,
    category:'App design',
    title: "Astarte Medical",
    slug: "Astarte-Medical",
    sub: "Computer Software",
    Industry: "Computer software",
    Country: "Germany, Issum",
    Technologies1: tImg1,
    Technologies2: tImg2,
    description:
      "Creating software for Astarte Medical involves a meticulous process aimed at addressing their specific needs and objectives. It begins with thorough research and planning to understand the requirements goals of the project.",
  },
  {
    Id: "8",
    pImg: pImg5,
    category:'App design',
    title: "CAE Blue Phantom",
    slug: "CAE-Blue-Phantom",
    sub: "Healthcare",
    Industry: "Wellness & Fitness",
    Country: "Canada, Alberta",
    Technologies1: tImg1,
    Technologies2: tImg3,
    description:
      "CAE Blue Phantom is a cutting-edge simulation technology designed to revolutionize medical training and education. Utilizing advanced virtual reality and artificial intelligence, CAE Blue Phantom provides.",
  },
  {
    Id: "9",
    pImg: pImg6,
    category:'App design',
    title: "Liberkeys",
    slug: "Liberkeys",
    sub: "Real Estate",
    Industry: "Real estate",
    Country: "France, Paris",
    Technologies1: tImg4,
    Technologies2: tImg5,
    description:
      "Liberkeys is a modern real estate platform that is revolutionizing the way people buy, sell, and rent properties. With a focus on transparency, efficiency, and customer satisfaction, Liberkeys streamlines.",
  },
  {
    Id: "10",
    pImg: pImg7,
    title:
      "Driving Digital Transformation Explore the Depth of Our IT Projects",
    slug: "Driving-Digital-Transformation-Explore-the-Depth-of-Our-IT Projects",
    thumb1: "Logo Design",
    thumb2: "Finance",
    category: "technology",
  },
  {
    Id: "17",
    pImg: pImg8,
    title: "Explore Our IT Solutions Portfolio for Public Sector Organizations",
    slug: "Explore-Our-IT-Solutions",
    thumb1: "App Design",
    thumb2: "Public",
    category: "Video",
  },
  {
    Id: "18",
    pImg: pImg9,
    title: "Innovative Solutions Showcase the Diversity of Our IT Portfolio",
    slug: "Innovative-Solutions-Showcase-the-Diversity-of-Our-IT-Portfolio",
    thumb1: "Card Design",
    thumb2: "Transpiration",
    category: "analysis",
  },
  {
    Id: "19",
    pImg: pImg10,
    title: "Tech Triumphs Celebrating Our Achievements in IT Solutions",
    slug: "Tech-Triumphs-Celebrating-Our-Achievements-in-IT-Solutions",
    thumb1: "Web Design",
    thumb2: "Logistic",
    category: "technology",
  },
  {
    Id: "20",
    pImg: pImg11,
    title:
      "Revolutionizing IT Strategies A Closer Look at Our Dynamic IT Solutions",
    slug: "Revolutionizing-IT-Strategies-A-Closer-Look-at-Our-Dynamic-IT-Solutions",
    thumb1: "Web Design",
    thumb2: "Fution",
    category: "analysis",
  },
  {
    Id: "21",
    pImg: pImg12,
    title: "Cloud Migration and Integration Project IT Solutions Portfolio",
    slug: "Cloud-Migration-and-Integration-Project-IT-Solutions-Portfolio",
    thumb1: "Web Design",
    thumb2: "Energy",
    category: "helpdesk",
  },
  {
    Id: "22",
    pImg: pImg13,
    title: "Pioneering Progress Exploring the Evolution and Impact of",
    slug: "Pioneering-Progress-Exploring-the-Evolution-and-Impact-of",
    thumb1: "Web Design",
    thumb2: "Health",
    category: "marketing",
  },
  {
    Id: "23",
    pImg: pImg14,
    title: "Unlocking Potential Explore Our Comprehensive IT Portfolio",
    slug: "Unlocking-Potential-Explore-Our-Comprehensive-IT-Portfolio",
    thumb1: "Web Design",
    thumb2: "Industry",
    category: "technology",
  },
];

export default Project;
